"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatPhoneNumberNational = exports.formatPhoneNumber = void 0;
const libphonenumber_js_1 = require("libphonenumber-js");
__exportStar(require("libphonenumber-js"), exports);
const formatPhoneNumber = function (phoneNumber) {
  let countryCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "US";
  let format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "E.164";
  return (0, libphonenumber_js_1.parsePhoneNumber)(phoneNumber, countryCode).format(format);
};
exports.formatPhoneNumber = formatPhoneNumber;
const formatPhoneNumberNational = phoneNumber => (0, libphonenumber_js_1.parsePhoneNumber)(phoneNumber).formatNational();
exports.formatPhoneNumberNational = formatPhoneNumberNational;